import { format, getMonth, parse, parseISO } from "date-fns";
import { uk } from "date-fns/locale";

export const months = [
  "Січень",
  "Лютий",
  "Березень",
  "Квітень",
  "Травень",
  "Червень",
  "Липень",
  "Серпень",
  "Вересень",
  "Жовтень",
  "Листопад",
  "Грудень",
];

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return format(date, "d MMMM yyyy", { locale: uk });
};

export const formatIOS = (value: string) => {
  const date = parse(value, "d MMMM yyyy", new Date(), { locale: uk });
  const isoLocal = new Date(
    date.getTime() - date.getTimezoneOffset() * 60000
  ).toISOString();
  return isoLocal;
};

export const getTimeMinHour = (value: string) => {
  return new Date(value).toLocaleTimeString("uk-UA", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

export const formatDateToUkrainian = (isoDate: string): string => {
  try {
    if (!isoDate) return "";
    const date = parseISO(isoDate);

    const formatted = format(date, "d MMMM yyyy", { locale: uk });
    const parsed = parse(formatted, "d MMMM yyyy", new Date(), { locale: uk });

    const day = parsed.getDate().toString();
    const monthIndex = getMonth(parsed); 
    const year = parsed.getFullYear().toString();

    return `${day} ${months[monthIndex]} ${year}`;
  } catch (err) {
    console.warn("❌ Помилка форматування дати:", err);
    return "";
  }
};

type MetricKey = "projects" | "tasks" | "comments";

export function getChangePercentTableStatisticByMetric<
  T extends Record<string, any>
>(data: T, countKey: `${MetricKey}Count`) {
  const baseKey = countKey.replace("Count", "") as MetricKey;
  const percentKey = `${baseKey}ChangePercent` as keyof T;

  return data[percentKey];
}
